import { createFileRoute } from '@tanstack/react-router';

import { ExpiredRoute } from '@mint-emails/recommendation/routes';

export const Route = createFileRoute('/recommendation/expired')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ExpiredRoute />;
}
